/* unplugin-vue-components disabled */import { render } from "./MenuLeft.vue?vue&type=template&id=3f29fe4c&scoped=true&ts=true"
import script from "./MenuLeft.vue?vue&type=script&lang=ts"
export * from "./MenuLeft.vue?vue&type=script&lang=ts"

import "./MenuLeft.vue?vue&type=style&index=0&id=3f29fe4c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f29fe4c"]])

export default __exports__